import { render, staticRenderFns } from "./Race.vue?vue&type=template&id=f6c16004&scoped=true&"
import script from "./Race.vue?vue&type=script&lang=js&"
export * from "./Race.vue?vue&type=script&lang=js&"
import style0 from "./Race.vue?vue&type=style&index=0&id=f6c16004&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6c16004",
  null
  
)

export default component.exports